import { Box, Skeleton, Typography, useTheme } from "@mui/material";
import { FC } from "react";
import { HELOCFormProps } from "typedef/HELOCFormProps";

const EstNetProceeds: FC<HELOCFormProps> = ({
  netFundingWiredToBankCalculation,
}) => {
  const theme = useTheme();

  return (
    <Box
      display="grid"
      gridTemplateColumns="1fr 2fr"
      alignItems="center"
      sx={{ backgroundColor: theme.palette.background.paper, p: 2 }}
    >
      <Typography variant="h6">Est. Net Proceeds</Typography>
      <Box display="flex" alignItems="center">
        {netFundingWiredToBankCalculation ? (
          <Typography
            variant="h5"
            color={theme.palette.text.primary}
            fontFamily={"Pro Display Bold"}
          >
            $
            {Math.floor(netFundingWiredToBankCalculation).toLocaleString(
              "en-US",
            )}
          </Typography>
        ) : (
          <Skeleton width="75%" height={"1.5rem"} />
        )}
      </Box>
    </Box>
  );
};

export default EstNetProceeds;
